import React, { useEffect, useRef } from "react";

const ExecuteScripts = ({ html }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Inject the HTML
    container.innerHTML = html;

    // Find all <script> tags
    const scripts = container.querySelectorAll("script");

    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");

      // Copy all attributes
      for (let attr of oldScript.attributes) {
        newScript.setAttribute(attr.name, attr.value);
      }

      // Copy the inline script content
      if (oldScript.innerHTML) {
        newScript.innerHTML = oldScript.innerHTML;
      }

      // Replace the old <script> with the new one (so it executes)
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }, [html]);

  return <div ref={containerRef} />;
};

export default ExecuteScripts;
